import { combineReducers } from 'redux';
import { put, takeEvery } from 'redux-saga/effects';
import prepareBody from '../utils/prepareBody';
import mergeArray from '../utils/mergeArray';
import { selectPlanId, selectArchived, selectRunnerId } from './auth';
import { SAVE_PREFERENCES_SUCCESS } from './preferences';
import { SAVE_PROFILE_SUCCESS, UPLOAD_AVATAR_SUCCESS } from './profile';

export const GET_RACE = 'race/GET_RACE';
export const GET_RACE_SUCCESS = 'race/GET_RACE_SUCCESS';
export const GET_RACE_FAILURE = 'race/GET_RACE_FAILURE';
export const CHANGE_PLAN = 'race/CHANGE_PLAN';
export const CHANGE_PLAN_SUCCESS = 'race/CHANGE_PLAN_SUCCESS';
export const CHANGE_PLAN_FAILURE = 'race/CHANGE_PLAN_FAILURE';

export function infoReducer(state = null, action) {
    switch (action.type) {
        case GET_RACE_SUCCESS: {
            const newResult = action.result;
            delete newResult.plan_id; // single truth for plan_id is 'auth' state object
            return {
                ...state,
                ...newResult,
                isMember: action.result.account_level === 'Membership',
                race_date: action.result.race_date,
                time_low: action.result.time_low,
                time_high: action.result.time_high,

            };
        }
        default:
            return state;
    }
}

export function errorReducer(state = null, action) {
    switch (action.type) {
        case GET_RACE:
        case GET_RACE_SUCCESS:
            return null;
        case GET_RACE_FAILURE:
            return action.error;
        default:
            return state;
    }
}

export function* refreshPlan() {
    return yield put(getRace());
}

export function* rootSaga() {
    yield takeEvery([
        CHANGE_PLAN_SUCCESS,
        SAVE_PREFERENCES_SUCCESS,
        SAVE_PROFILE_SUCCESS,
        UPLOAD_AVATAR_SUCCESS,
    ], refreshPlan);
}

export default combineReducers({
    info: infoReducer,
    error: errorReducer,
});

export const getRace = () => ({
    types: [GET_RACE, GET_RACE_SUCCESS, GET_RACE_FAILURE],
    promise: ({ getState }) => fetch(`${process.env.RTAPI_URL}/API_plan.php`, {
        method: 'POST',
        body: prepareBody({
            plan_id: selectPlanId(getState()),
            runner_id: selectRunnerId(getState()),
            Version: selectArchived(getState()),
        }),
    }).then(res => res.json()).then(mergeArray),
});

export const changeTrainingPlan = body => ({
    types: [CHANGE_PLAN, CHANGE_PLAN_SUCCESS, CHANGE_PLAN_FAILURE],
    promise: ({ getState }) => fetch(`${process.env.RTAPI_URL}/API_change_plan.php`, {
        method: 'POST',
        body: prepareBody({
            ...body,
            plan_id: selectPlanId(getState()),
            runner_id: selectRunnerId(getState()),
        }),
    }).then(res => res.json()),
});

export const isTFK = themeId => themeId === '7';




/** WEBPACK FOOTER **
 ** ./src/redux/race.js
 **/